import { useState } from 'react';
import { Button } from '@/components/ui/button';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import { useSwap } from '@/contexts/SwapProvider';
import { Label } from '@/components/ui/label';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import classNames from '@/lib/misc/classNames';
interface SettingOption {
  label: string;
  value: string | number;
}
interface SettingsControlProps {
  title: string;
  options: SettingOption[];
  defaultValue: string | number;
  unit?: string;
  setValueFunc?: (value: string | number) => void;
}
export function SettingsControl({
  title,
  options,
  defaultValue,
  unit = '',
  setValueFunc
}: SettingsControlProps) {
  const defaultValues = [0.3, 0.5, 1];
  const [selectedValue, setSelectedValue] = useState<string | number>(defaultValue);
  const [customValue, setCustomValue] = useState<string>(defaultValues?.includes(defaultValue) ? '' : defaultValue?.toString());
  const [isCustom, setIsCustom] = useState(defaultValues?.includes(defaultValue) ? false : true);
  const handleOptionClick = (value: string | number) => {
    setSelectedValue(value);
    if (setValueFunc) {
      setValueFunc(value);
    }
    setCustomValue('');
    setIsCustom(false);
  };
  const handleCustomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setValueFunc(1);
      setSelectedValue(1);
      setIsCustom(false);
      setCustomValue('');
    }
    setCustomValue(e.target.value);
    if (setValueFunc) {
      setValueFunc(e.target.value);
    }
    if (!e.target.value) {
      setValueFunc(1);
    }
    if (isCustom) {
      setSelectedValue(e.target.value);
      if (!e.target.value) {
        setSelectedValue(1);
      }
    }
  };
  return <div className='mb-4' data-sentry-component="SettingsControl" data-sentry-source-file="SwapSettings.tsx">
      <h2 className='text-lg mb-4 text-white ta-l text-sm font-light'>{title}</h2>
      <p className='text-xs pb-4 text-genius-cream/50 text-left'>
        Your slippage settings will persist for future trades in this session.
      </p>
      <div className='flex items-center justify-center space-x-2 mb-2 border-genius-blue border-2 h-[56px] rounded-full p-1'>
        {options.map(option => <Button key={option.value} onClick={() => handleOptionClick(option.value)} className={`font-light w-1/3 h-full text-xs bg-genius-indigo text-genius-cream/50 md:hover:bg-genius-blue px-2 rounded-full ${selectedValue === option.value && !customValue && 'bg-genius-blue text-genius-cream'}`}>
            {option.label}
          </Button>)}
      </div>

      <div className={`font-light rounded-lg flex items-center w-full pt-2`}>
        <div className='w-full relative h-fit ta-l'>
          <Label className='text-genius-cream/50 text-[12px]' data-sentry-element="Label" data-sentry-source-file="SwapSettings.tsx">Custom</Label>
          <input type='text' value={customValue} onChange={handleCustomChange} className='bg-genius-indigo w-full h-[56px] pl-2 mt-4 rounded-lg text-genius-cream/50 text-xs border border-genius-blue' />
          <span className='text-genius-cream text-xs absolute right-3 top-[60px]'>{unit}</span>
        </div>
      </div>
    </div>;
}
export default function SwapSettings({
  isModalOpen,
  toggleModal
}) {
  const {
    setFromConfig,
    fromConfig
  } = useSwap();
  const isMobile = useIsMobile();
  const content = () => {
    return <div className='pb-0 pt-4 px-4 bg-genius-indigo' data-sentry-component="content" data-sentry-source-file="SwapSettings.tsx">
        <SettingsControl title='Slippage' setValueFunc={(value: string) => setFromConfig({
        ...fromConfig,
        slippage: parseFloat(value)
      })} options={[{
        label: '0.3%',
        value: 0.3
      }, {
        label: '0.5%',
        value: 0.5
      }, {
        label: '1%',
        value: 1
      }]} defaultValue={fromConfig.slippage} unit='%' data-sentry-element="SettingsControl" data-sentry-source-file="SwapSettings.tsx" />
        <Button onClick={() => {
        if (!fromConfig.slippage) {
          setFromConfig({
            ...fromConfig,
            slippage: 1
          });
        }
        toggleModal();
      }} className='rounded-full w-full mt-2 mb-2 bg-genius-pink text-genius-indigo h-14' variant='pink' data-sentry-element="Button" data-sentry-source-file="SwapSettings.tsx">
          Confirm
        </Button>
      </div>;
  };
  return <>
      {isMobile ? <SlidingModal heightFit={true} isOpen={isModalOpen} onClose={() => {
      if (!fromConfig.slippage) {
        setFromConfig({
          ...fromConfig,
          slippage: 1
        });
      }
      toggleModal();
    }}>
          {content()}
        </SlidingModal> : <Dialog open={isModalOpen} onOpenChange={() => {
      toggleModal();
    }}>
          <DialogContent className={classNames('  bg-genius-indigo   p-0  text-genius-cream text-sm h-fit  overflow-y-scroll no-scrollbar')}>
            {content()}
          </DialogContent>
        </Dialog>}
    </>;
}